/**
 * Pure helpers for gist.is web pages that share extension + Firebase auth.
 *
 * Used by /options, /help, and similar surfaces.
 *
 * @file src/client/web-auth-session-gate.ts
 */

/** Minimal Firebase user shape for auth-gate checks (avoids importing firebase/auth in tests). */
export interface WebAuthFirebaseUser {
  uid: string;
}

/**
 * Signed-out UI only when neither Firebase nor the extension reports a session.
 */
export function shouldShowSignedOutWebUi(args: {
  firebaseUser: WebAuthFirebaseUser | null;
  workerToken: string | null;
  cookieAuthenticated?: boolean;
}): boolean {
  return !args.firebaseUser && !args.workerToken && args.cookieAuthenticated !== true;
}
